import Rating from "@mui/material/Rating";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../Contexts/GlobalContext";
import { GTM_TRACKER } from "../../GoogleAnaytics/gtmConstants";
import { goToDashboard, startFreeTrial } from "../../courses/Strategies/RedirectionStrategy";
import useWindowDimensions from "../../hooks/UseWindowDimensions";
import CompanyLogo from "../../img/Company_Logos_Low_Level_Design.webp";
import IntroLogo from "../../img/LowLevelIntroLogo.webp";
import IntroPointsMobile from "./IntroPointsMobile";
import "./styles/Intro.css";

const IntroMobile = () => {
    const navigate = useNavigate();
    const redirectUser = (link) => navigate(link);
    const { loggedIn, everSubscribed, freeTrialFormFilled } = useGlobalContext();
    const { windowWidth } = useWindowDimensions();

    function GetFreeTrialButton() {
        return (
            <div className="free-trial-btn-wrapper">
                <button onClick={() => startFreeTrial(freeTrialFormFilled, redirectUser)}>
                    Start Free Trial
                </button>
            </div>
        );
    }

    function GetDashBoardButton() {
        return (
            <div className="free-trial-btn-wrapper">
                <button onClick={() => goToDashboard()}>Go to Dashboard</button>
            </div>
        );
    }

    function GetSignupButton() {
        return (
            <div className={`${GTM_TRACKER.START_FREE_TRIAL} free-trial-btn-wrapper`}>
                <button
                    onClick={() => {
                        navigate("/signup");
                    }}
                >
                    Try 7-day Free Trial
                </button>
            </div>
        );
    }

    function GetFreeTrailOrDashboardButton() {
        if (!loggedIn) return <GetSignupButton />;
        else if (!everSubscribed) return <GetFreeTrialButton />;
        else return <GetDashBoardButton />;
    }

    return (
        <div className="intro-wrapper">
            <div className="intro-contents-wrapper">
                <h1 className="heading">
                    Master Low Level Design and Concurrency for{" "}
                    <span className="blue-heading">Software Professionals</span>{" "}
                </h1>
                <p className="desc">
                    Crack Design and Machine Coding Rounds for
                    <br /> Senior Software Engineer Roles
                </p>
            </div>

            <div className="intro-image-wrapper">
                <div className="image-wrapper">
                    <img src={IntroLogo} alt="" />
                </div>
                <IntroPointsMobile />

                <div className="star-rating-wrapper">
                    <Rating
                        sx={{ color: "#444BAB" }}
                        name="half-rating-read"
                        defaultValue={5}
                        readOnly
                        size="medium"
                    />
                    <p className="star-rating-text">
                        Our courses are rated <strong>4.9</strong>/5 by{" "}
                        <strong>5k+ students</strong>
                    </p>
                    {windowWidth <= 600 && (
                        <div className="signup-mob">
                            <GetFreeTrailOrDashboardButton />
                            <span className="free-lectures">
                                Watch 10+ lectures and a case study for <strong>free</strong>
                            </span>
                        </div>
                    )}
                </div>

                <div className="company-logo-wrapper">
                    <p>Covers required skillsets by Top Tech and HFT Firms like:</p>
                    <div className="company-logo-img">
                        <img src={CompanyLogo} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntroMobile;
